import * as React from 'react';
import { DirectionalHint } from '@fluentui/react/lib/Callout';
import { ButtonType } from '@fluentui/react/lib/Button';
import { TeachingBubble } from '@fluentui/react/lib/TeachingBubble';
import { observer } from 'mobx-react-lite';
import { Lightable, lighted, LightningId } from 'owa-lightning-v2';
import loc from 'owa-localize';
import {
    proofingTeachingBubbleHeadlinePremiumUser,
    proofingTeachingBubbleBodyPremiumUser,
    proofingTeachingBubbleConfirmButton,
} from './ProofingTeachingCallout.locstring.json';

export interface ProofingTeachingCalloutPremiumUserProps {
    target: () => HTMLElement;
}

export default observer(function ProofingTeachingCalloutPremiumUser(
    props: ProofingTeachingCalloutPremiumUserProps
) {
    const lid: LightningId = LightningId.ProofingTeachingPremiumUserFRE;
    const headline: string = loc(proofingTeachingBubbleHeadlinePremiumUser);
    const body: string = loc(proofingTeachingBubbleBodyPremiumUser);
    const buttonText: string = loc(proofingTeachingBubbleConfirmButton);
    const when = lightup => {
        setTimeout(lightup, 1500);
    };
    const onClose = () => {
        lighted(lid);
    };

    return (
        <Lightable lid={LightningId.ProofingTeachingPremiumUserFRE} when={when}>
            <TeachingBubble
                calloutProps={{
                    beakWidth: 12,
                    directionalHint: DirectionalHint.topCenter,
                }}
                targetElement={props.target()}
                hasCloseIcon={true}
                onDismiss={onClose}
                hasSmallHeadline={true}
                headline={headline}
                primaryButtonProps={{
                    buttonType: ButtonType.primary,
                    children: buttonText,
                    onClick: onClose,
                }}>
                {body}
            </TeachingBubble>
        </Lightable>
    );
});
